import React from "react";
import locationIcon from "../../src/assets/s1-loc-icon.svg";
import sendIcon from "../../src/assets/s1-arrow-btn.svg";
import Welcome from "../../src/assets/electric-car.png";

export default function EnterDestination({ onNext }) {
  const welcomeTextStyle = {
    fontFamily: "'Roboto Flex', sans-serif",
    fontSize: "30px",
    fontWeight: 600,
    lineHeight: "40px",
    textAlign: "center",
    color: "#096960",
    marginBottom: "10px",
  };

  const imageStyle = {
    marginTop: "-20px", // Adjust this value as needed
  };

  return (
    <div className="flex flex-col items-center">
      <style>
        {`
          @keyframes letterAnimation {
            0% { opacity: 0; transform: translateX(-50px); }
            50% { opacity: 1; transform: translateX(0); }
            100% { opacity: 0; transform: translateX(-50px); }
          }
        `}
      </style>

      <div>
        <img src={Welcome} alt="carimage" style={imageStyle} />
      </div>
      <p style={welcomeTextStyle}>Welcome to OHM Electric Cabs</p>

      <div className="relative w-full flex justify-center">
        <div className="w-[450px] h-[50px] rounded-lg bg-white flex items-center shadow-md border-2 border-[#50AEB5]">
          <div className="pl-2">
            <img src={locationIcon} alt="location" className="text-gray-400" />
          </div>
          <input
            type="text"
            className="pl-12 pr-3 w-full bg-transparent border-none outline-none text-gray-500"
            placeholder="Enter destination"
          />
          <div className="pr-2">
            <img src={sendIcon} alt="Send icon" onClick={onNext} />
          </div>
        </div>
      </div>
      <div className="scanner">
        <span>VIABLY SUSTAINABLE</span>
      </div>
    </div>
  );
}
